import React, { createContext, useState, useCallback } from 'react';

export const APIErrorContext = createContext({
    error: null,
    addError: () => {},
    removeError: () => {},
});

const APIErrorProvider = ({ children }) => {
    const [error, setError] = useState(null);

    const removeError = () => setError(null);
    const addError = (message, status) => setError({ message, status });

    // TO DO https://paygreen.atlassian.net/browse/PGF-736
    const contextValue = {
        error,
        addError: useCallback((message, status) => {
            typeof message === 'string'
                ? addError(message, status)
                : console.error(
                      'There is a problem with error format received from API',
                      JSON.stringify(message) + '& this is status ' + status, // we stringify message to display its content when format is not the expected one
                  );
        }, []),
        removeError: useCallback(() => removeError(), []),
    };

    return (
        <APIErrorContext.Provider value={contextValue}>
            {children}
        </APIErrorContext.Provider>
    );
};

export default APIErrorProvider;
